import PDFMake from 'pdfmake'
import pdfFonts from 'pdfmake/build/vfs_fonts'
import { ContractType } from '@/utils/Enumerations'
import { utcToLocalDate } from '@/utils/DateFormatter'
import CryptoJS from 'crypto-js'
import i18n from '@/i18n'

PDFMake.vfs = pdfFonts.pdfMake.vfs

export function getContractQrCodeData (contractId, tenantCode, optionalParam) {
  const payload = {
    type: 'contract',
    v: 2,
    id: contractId,
    param: optionalParam
  }

  const key = CryptoJS.enc.Utf8.parse(tenantCode.padEnd(32, '0'))
  const iv = CryptoJS.lib.WordArray.random(16)
  const encryptedMessage = CryptoJS.AES.encrypt(JSON.stringify(payload), key, { mode: CryptoJS.mode.CBC, iv: iv })

  const ap = CryptoJS.enc.Base64.stringify(encryptedMessage.ciphertext) + ':' + CryptoJS.enc.Base64.stringify(encryptedMessage.iv)

  const qrContent = {
    ap: ap
  }

  return JSON.stringify(qrContent)
}

export async function generateContractIdSheetPDF (contract, qrCode, additionalText, listProducts = false) {
  const FIELD_INDENT = 25
  const FIELD_ROW_SPACING = 5
  const FIELD_ROW_PADDING = 1
  const FIELD_LAST_ROW_PADDING = 3
  const PAGE_TOP_MARGIN = 40
  const QR_SIZE = 150
  const QR_ALIGN_TOP = 17
  const QR_TOP_MARGIN = 10
  const PRODUCT_INDENT = 5
  const BUBBLE_COL_WIDTH = 12

  const cardTitle = () => ({ text: i18n.t('contractIdentificationSheet'), style: 'title', margin: [0, 0, 0, 0] })
  const cardFooter = () => [
    { text: i18n.t('scanCodeAtScaleToWeighIn'), italics: false, fontSize: 12, alignment: 'center', margin: [0, 5, 0, 3] },
    { text: i18n.t('generatedUsingAngelByLegnaSoftware'), italics: true, fontSize: 8, alignment: 'center', margin: [0, 0, 0, 0] }
  ]

  const gatePassTypeRow = (topMargin = FIELD_ROW_SPACING) => (additionalText)
    ? [{ text: additionalText, style: 'subtitle', margin: [FIELD_INDENT, topMargin, 0, FIELD_ROW_PADDING], alignment: 'left', listType: 'none' }]
    : []

  const passContent = () => {
    if (contract.type === ContractType.LogYardSale.value) {
      return [
        { text: `${i18n.t('destination')}: ${contract.destination}`, style: 'subtitle', margin: [FIELD_INDENT, QR_ALIGN_TOP, 0, FIELD_ROW_PADDING], alignment: 'left', listType: 'none' },
        { text: `${i18n.t('fromAccount')}: ${contract.fromAccount}`, style: 'subtitle', margin: [FIELD_INDENT, FIELD_ROW_SPACING, 0, FIELD_ROW_PADDING], alignment: 'left', listType: 'none' },
        { text: `${i18n.t('account')}: ${contract.account}`, style: 'subtitle', margin: [FIELD_INDENT, FIELD_ROW_SPACING, 0, FIELD_ROW_PADDING], alignment: 'left', listType: 'none' },
        { text: `${i18n.t('expirationDate')}: ${utcToLocalDate(contract.expirationDate)}`, style: 'subtitle', margin: [FIELD_INDENT, FIELD_ROW_SPACING, 0, FIELD_LAST_ROW_PADDING], alignment: 'left', listType: 'none' },
        ...gatePassTypeRow()
      ]
    } else if (contract.type !== ContractType.Transfer.value && contract.type !== ContractType.ByproductSale.value && contract.type !== ContractType.ByproductPurchase.value) {
      return [
        { text: `${i18n.t('destination')}: ${contract.destination}`, style: 'subtitle', margin: [FIELD_INDENT, QR_ALIGN_TOP, 0, FIELD_ROW_PADDING], alignment: 'left', listType: 'none' },
        { text: `${i18n.t('tract')}: ${contract.tract ?? 'N/A'}`, style: 'subtitle', margin: [FIELD_INDENT, FIELD_ROW_SPACING, 0, FIELD_ROW_PADDING], alignment: 'left', listType: 'none' },
        { text: `${i18n.t('account')}: ${contract.account}`, style: 'subtitle', margin: [FIELD_INDENT, FIELD_ROW_SPACING, 0, FIELD_ROW_PADDING], alignment: 'left', listType: 'none' },
        { text: `${i18n.t('logger')}: ${contract.tractDefaultLogger ?? 'N/A'}`, style: 'subtitle', margin: [FIELD_INDENT, FIELD_ROW_SPACING, 0, FIELD_ROW_PADDING], alignment: 'left', listType: 'none' },
        { text: `${i18n.t('setting')}: ${contract.setting ?? 'N/A'}`, style: 'subtitle', margin: [FIELD_INDENT, FIELD_ROW_SPACING, 0, FIELD_ROW_PADDING], alignment: 'left', listType: 'none' },
        { text: `${i18n.t('expirationDate')}: ${utcToLocalDate(contract.expirationDate)}`, style: 'subtitle', margin: [FIELD_INDENT, FIELD_ROW_SPACING, 0, FIELD_LAST_ROW_PADDING], alignment: 'left', listType: 'none' }
      ]
    } else if (contract.type === ContractType.ByproductSale.value) {
      return [
        { text: `${i18n.t('destination')}: ${contract.destination}`, style: 'subtitle', margin: [FIELD_INDENT, QR_ALIGN_TOP, 0, FIELD_ROW_PADDING], alignment: 'left', listType: 'none' },
        { text: `${i18n.t('fromAccount')}: ${contract.fromAccount}`, style: 'subtitle', margin: [FIELD_INDENT, FIELD_ROW_SPACING, 0, FIELD_ROW_PADDING], alignment: 'left', listType: 'none' },
        { text: `${i18n.t('account')}: ${contract.account}`, style: 'subtitle', margin: [FIELD_INDENT, FIELD_ROW_SPACING, 0, FIELD_ROW_PADDING], alignment: 'left', listType: 'none' },
        { text: `${i18n.t('expirationDate')}: ${utcToLocalDate(contract.expirationDate)}`, style: 'subtitle', margin: [FIELD_INDENT, FIELD_ROW_SPACING, 0, FIELD_LAST_ROW_PADDING], alignment: 'left', listType: 'none' },
        { text: additionalText, style: 'subtitle', margin: [FIELD_INDENT, FIELD_ROW_SPACING, 0, FIELD_ROW_PADDING], alignment: 'left', listType: 'none' }
      ]
    } else {
      return [
        { text: `${i18n.t('destination')}: ${contract.destination}`, style: 'subtitle', margin: [FIELD_INDENT, 30, 0, FIELD_ROW_SPACING], alignment: 'left', listType: 'none' },
        { text: `${i18n.t('fromAccount')}: ${contract.fromAccount}`, style: 'subtitle', margin: [FIELD_INDENT, FIELD_ROW_SPACING], alignment: 'left', listType: 'none' },
        { text: `${i18n.t('account')}: ${contract.account}`, style: 'subtitle', margin: [FIELD_INDENT, FIELD_ROW_SPACING], alignment: 'left', listType: 'none' },
        { text: `${i18n.t('expirationDate')}: ${utcToLocalDate(contract.expirationDate)}`, style: 'subtitle', margin: [FIELD_INDENT, FIELD_ROW_SPACING], alignment: 'left', listType: 'none' },
        ...gatePassTypeRow()
      ]
    }
  }

  const pass = () => [
    cardTitle(),
    {
      columns: [
        {
          ol: passContent()
        },
        { image: qrCode, width: QR_SIZE, margin: [0, QR_ALIGN_TOP, FIELD_INDENT, 0], alignment: 'center' }
      ]
    },
    ...cardFooter()
  ]

  const divider = () => [
    {
      canvas: [
        { type: 'line', x1: 0, y1: 0, x2: 515, y2: 0, lineWidth: 1, dash: { length: 5, space: 10 } }
      ],
      margin: [0, 19, 0, 19]
    }
  ]

  // List Products Mode
  const products = listProducts
    ? [...(contract.products ?? [])].sort((a, b) => (a.sortOrder ?? 0) - (b.sortOrder ?? 0))
    : []

  const productFields = () => [
    { text: `${i18n.t('destination')}: ${contract.destination}`, style: 'productSubtitle' },
    { text: `${i18n.t('tract')}: ${contract.tract ?? 'N/A'}`, style: 'productSubtitle' },
    { text: `${i18n.t('account')}: ${contract.account}`, style: 'productSubtitle' },
    { text: `${i18n.t('logger')}: ${contract.tractDefaultLogger ?? 'N/A'}`, style: 'productSubtitle' },
    { text: `${i18n.t('setting')}: ${contract.setting ?? 'N/A'}`, style: 'productSubtitle' },
    { text: `${i18n.t('expirationDate')}: ${utcToLocalDate(contract.expirationDate)}`, style: 'productSubtitle' }
  ]

  const productsHeading = (leftMargin) => ({ text: i18n.t('contractProducts'), style: 'productHeading', margin: [leftMargin, 6, 0, 3] })

  const bubbleCell = () => ({ canvas: [{ type: 'ellipse', x: BUBBLE_COL_WIDTH / 2, y: 7, r1: 4, r2: 4, lineWidth: 1 }], margin: [0, 1, 0, 0] })

  const productGridLayout = {
    hLineWidth: () => 0,
    vLineWidth: () => 0,
    paddingLeft: () => 0,
    paddingRight: () => 2
  }

  const productGrid = (cols, leftMargin) => {
    const rows = Math.ceil(products.length / cols)
    const widths = []
    for (let c = 0; c < cols; c++) widths.push(BUBBLE_COL_WIDTH, '*')

    const body = []
    for (let r = 0; r < rows; r++) {
      const cells = []
      for (let c = 0; c < cols; c++) {
        const product = products[c * rows + r]
        if (product) {
          cells.push(bubbleCell(), { text: product.name, style: 'productItem', fontSize: cols === 3 ? 9.5 : 10, margin: [2, 1, 0, 1] })
        } else {
          cells.push({ text: '' }, { text: '' })
        }
      }
      body.push(cells)
    }

    return { table: { widths, body, dontBreakRows: true }, layout: productGridLayout, margin: [leftMargin, 0, 0, 0] }
  }

  const qrRow = (leftStack) => ({
    columns: [
      { width: '*', stack: leftStack, margin: [PRODUCT_INDENT, QR_TOP_MARGIN, 0, 0] },
      { image: qrCode, width: QR_SIZE, margin: [0, QR_TOP_MARGIN, 0, 0] }
    ],
    columnGap: 10
  })

  const passWithProducts = (besideQr) => {
    const belowQr = besideQr
      ? []
      : [productsHeading(PRODUCT_INDENT), productGrid(3, PRODUCT_INDENT)]

    return [
      cardTitle(),
      qrRow(besideQr ? [...productFields(), productsHeading(0), productGrid(2, 0)] : productFields()),
      ...belowQr,
      ...cardFooter()
    ]
  }

  const styles = {
    title: {
      fontSize: 16,
      bold: true,
      alignment: 'center'
    },
    subtitle: {
      fontSize: 14,
      bold: false,
      alignment: 'center'
    },
    productSubtitle: {
      fontSize: 11,
      bold: false,
      alignment: 'left',
      margin: [0, 1, 0, 1]
    },
    productHeading: {
      fontSize: 11,
      bold: true,
      alignment: 'left'
    },
    productItem: {
      fontSize: 10,
      alignment: 'left'
    }
  }

  const basePdfOptions = () => ({ defaultStyle: { margin: [0, 0] }, styles })

  // eslint-disable-next-line no-useless-escape
  const encode = (string) => (string ?? '').trim().replace(' ', '_').replace(/[\\<>:"\/\|\?\*~#%&+{}[\]';,`@!^$\.]+/g, '')

  let fileName = `cid-${encode(contract.tract)}-${encode(contract.destination)}`
  if (contract.type === ContractType.ByproductPurchase.value) {
    fileName = `cid-${encode(contract.fromAccount)}-${encode(contract.destination)}`
  } else if (contract.type === ContractType.ByproductSale.value) {
    fileName = `BPS-${encode(contract.fromAccount)}-${encode(contract.destination)}-${encode(contract.account)}`
  } else if (contract.type === ContractType.LogYardSale.value) {
    fileName = `LYS-${encode(contract.fromAccount)}-${encode(contract.destination)}-${encode(contract.account)}`
  } else if (contract.type === ContractType.Transfer.value) {
    fileName = `TRN-${encode(contract.fromAccount)}-${encode(contract.destination)}`
  }

  if (listProducts && products.length > 0) {
    const buildProductContent = (cardCount, besideQr) => {
      const cards = []
      for (let i = 0; i < cardCount; i++) {
        cards.push(...passWithProducts(besideQr))
        if (i < cardCount - 1) cards.push(...divider())
      }
      return cards
    }

    const probeLayout = (content, inspectNode) => new Promise((resolve) => {
      PDFMake.createPdf({
        content,
        ...basePdfOptions(),
        pageBreakBefore: (node) => { inspectNode(node); return false }
      }).getBase64(() => resolve())
    })

    const probeFits = async (cardCount, besideQr) => {
      let overflow = false
      await probeLayout(buildProductContent(cardCount, besideQr), (node) => {
        const pages = node.pageNumbers ?? (node.startPosition ? [node.startPosition.pageNumber] : [])
        if (pages.length && Math.max(...pages) > 1) overflow = true
      })
      return !overflow
    }

    const measureFieldsFitBesideQr = async () => {
      let maxTop = 0
      await probeLayout([qrRow(productFields()), { text: ' ' }], (node) => {
        if (node.startPosition) maxTop = Math.max(maxTop, node.startPosition.top)
      })
      return maxTop - PAGE_TOP_MARGIN <= QR_TOP_MARGIN + QR_SIZE + 0.5
    }

    const downloadWithCards = (cardCount, besideQr) => {
      PDFMake.createPdf({
        content: buildProductContent(cardCount, besideQr),
        ...basePdfOptions()
      }).download(fileName)
    }

    const besideQr = products.length <= 6 ? await measureFieldsFitBesideQr() : false
    const cardCount = await probeFits(3, besideQr) ? 3 : (await probeFits(2, besideQr) ? 2 : 1)
    downloadWithCards(cardCount, besideQr)
    return
  }

  const content = []
  content.push(...pass(), ...divider())
  content.push(...pass(), ...divider())
  content.push(...pass())

  PDFMake.createPdf({
    content,
    ...basePdfOptions()
  }).download(fileName)
}
